import type {Dispatch, SetStateAction} from "react";
import {GenericModal} from "~/components/genericModal";
import {AnankeButton} from "@vesta/ananke/components/anankeButton";
import {VerticalSpacer} from "@vesta/global-common-typescript/components/verticalSpacer";

export type ArchiveItemType = "event" | "journey";

export function ArchiveConfirmationModal({
    isOpen,
    setIsOpen,
    itemType,
    onConfirm,
    isLoading,
}: {
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
    itemType: ArchiveItemType;
    onConfirm: () => Promise<void>;
    isLoading: boolean;
}) {
    const itemTypeDisplayName = itemType === "event" ? "event" : "journey";

    return (
        <GenericModal
            onClose={() => setIsOpen(false)}
            opened={isOpen}
            withCloseButton={false}
            title={`Archive ${itemTypeDisplayName}`}
            size="md"
            zIndex={10000}
        >
            <div>
                Are you sure you want to archive this {itemTypeDisplayName}? This action can be reversed later.
            </div>

            <VerticalSpacer className="h-4" />

            <div className="w-full grid grid-flow-col justify-end gap-2">
                <AnankeButton
                    type="button"
                    onClick={() => setIsOpen(false)}
                    appearance="default"
                    isDisabled={isLoading}
                >
                    Cancel
                </AnankeButton>

                <AnankeButton
                    type="button"
                    appearance="warning"
                    onClick={async () => {
                        await onConfirm();
                    }}
                    isLoading={isLoading}
                >
                    Yes, archive
                </AnankeButton>
            </div>
        </GenericModal>
    );
}
